import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BookingPage from "./pages/BookingPage";
import AdminPage from "./pages/AdminPage";
import AboutPage from "./pages/AboutPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import BlogListPage from "./pages/BlogListPage";
import BlogPostDummyTicket from "./pages/BlogPostDummyTicket";
import BlogPostSchengenVisa from "./pages/BlogPostSchengenVisa";
import BlogPostJapanVisa from "./pages/BlogPostJapanVisa";
import BlogPostJapanVisaChecklist from "./pages/BlogPostJapanVisaChecklist";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BookingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route
          path="/blog/what-is-a-dummy-ticket"
          element={<BlogPostDummyTicket />}
        />
        <Route
          path="/blog/flight-reservation-for-schengen-visa"
          element={<BlogPostSchengenVisa />}
        />
        <Route
          path="/blog/japan-visa-flight-reservation-india"
          element={<BlogPostJapanVisa />}
        />
        <Route
          path="/blog/japan-visa-checklist-india"
          element={<BlogPostJapanVisaChecklist />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
